<template>
  <section class="modal-backdrop">
    <div
      class="modal-container standard-size"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDescription"
    >
      <!-- Header -->
      <div class="modal-container__header">
        <h2 class="h1">SELECT A LANGUAGE</h2>
        <div style="cursor: pointer" @click="close()">
          <v-icon name="times" scale="1.5"></v-icon>
        </div>
      </div>

      <div class="modal-container__content">

        <!-- Languages dropdown -->
        <div class="input-group">
          <GlobalInputDropdown
            label="Country"
            v-model="selectedLanguage"
            :options="languagesArray"
          />
        </div>
        <div v-if="showError" class="error-text">
          <p>{{errorMessage}}</p>
        </div>

        <!-- Button Container -->
        <div class="button-container">
          <button class="button-neutral" @click="close()">Cancel</button>
          <button class="button-positive" @click="btnSave()">Save</button>
        </div>
      </div>

      <fetching-loader
        displayType="displayFixed"
        v-if="fetchingDataLoader"
      ></fetching-loader>

    </div>
  </section>
</template>

<script>
import { db } from "@/firebase";
import languages from "@/languages.json";
import GlobalInputDropdown from "@/components/GlobalComponents/GlobalInputDropdown";
import FetchingLoader from "@/components/GlobalComponents/FetchingLoader";
import newLanguageTypesFormatMixin from "@/mixins/newLanguageTypesFormatMixin";
/* eslint-disable */
export default {
  components: {
    GlobalInputDropdown,
    FetchingLoader
  },
  mixins: [newLanguageTypesFormatMixin],
  data() {
    return {      
      selectedLanguage: 'None',
      languagesArray: languages,
      showError: false,
      fetchingDataLoader: false,
      errorMessage: 'Please choose a country'
    };
  },
  mounted() {
    document.addEventListener("keydown", this.closeWindow);
  },
  destroyed() {
    document.removeEventListener("keydown", this.closeWindow);
  },
  methods: {
    closeWindow(e) {
      if (e.keyCode == 27) {
        this.close();
      }
    },
    close() {
      this.$emit("close");
    },
    async btnSave() {

      this.fetchingDataLoader = true;
      this.showError = false;

      if (this.selectedLanguage === 'None') {
        this.fetchingDataLoader = false;
        this.showError = true;
        this.errorMessage = 'Please choose a country';
        return;
      }  

      const currentLanguageTypes = (await db.ref(`customers/${this.$customerId}/languageTypes`).once("value")).val();
      const languageAlreadyEnabled = currentLanguageTypes.includes(this.selectedLanguage);

      if (languageAlreadyEnabled) {
        this.fetchingDataLoader = false;
        this.showError = true;
        this.errorMessage = 'Language already enabled';
        return;
      } else {
        const newLanguageArray = [...currentLanguageTypes];
        newLanguageArray.push(this.selectedLanguage);
        await db.ref(`customers/${this.$customerId}/languageTypes`).set(newLanguageArray);
      }
      
      const selectedLanguageObject = (await db.ref(`languages/${this.selectedLanguage}`).once("value")).val()
      
      if (!selectedLanguageObject) {
        await this._updateLanguagesInFirebase(this.selectedLanguage);
      }

      this.fetchingDataLoader = false;
      this.$toastEvents.push({
        type: "positive",
        title: "Awesome!",
        content: "Language option has been added",
        id: +new Date(),
      });

      this.$emit('addedLanguage');

      this.close();

    },
  },
};
</script>

<style scoped>

.input-group .h2 {
  margin-top: 24px;
  margin-bottom: 16px;
}

.error-text {
  color: var(--alert);
}
</style>
